/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { translate } from '@utils/i18n';
import { Text } from '@ui/atoms/Text';
export function DeficiencyIdCell({ dataItem, onDeficiencyClick }) {
    if (!onDeficiencyClick) {
        return (React.createElement("td", null,
            React.createElement(Text, null,
                "#",
                dataItem.id)));
    }
    return (React.createElement("td", null,
        React.createElement(Text, { variant: "link", as: "a", href: "#", onClick: (e) => {
                e.preventDefault();
                onDeficiencyClick(dataItem.id);
            } }, dataItem.id)));
}
export function InspectionIdCell({ dataItem }) {
    if (!dataItem.reports || dataItem.reports.length === 0) {
        return (React.createElement("td", null,
            React.createElement(Text, null, dataItem.inspection)));
    }
    return (React.createElement("td", null,
        React.createElement("div", { className: "inspection-reports-list" }, dataItem.reports.map((report) => {
            if (!report.reportPath) {
                return React.createElement(Text, { key: report.inspectionId }, report.inspectionId);
            }
            return (React.createElement(Text, { key: report.inspectionId, variant: "link", as: "a", href: report.reportPath, target: "_blank", rel: "noopener noreferrer" }, report.inspectionId));
        }))));
}
export function BuildingCell({ dataItem }) {
    if (!dataItem.buildingPath) {
        return (React.createElement("td", null,
            React.createElement(Text, null, dataItem.building)));
    }
    return (React.createElement("td", null,
        React.createElement(Text, { variant: "link", as: "a", href: dataItem.buildingPath, target: "_blank", rel: "noopener noreferrer" }, dataItem.building)));
}
export function DetailsCell({ dataItem }) {
    const assetDetailsIsEmpty = (typeof dataItem.assetDetails === 'object' && Object.keys(dataItem.assetDetails).length === 0) ||
        !dataItem.assetDetails;
    if (assetDetailsIsEmpty) {
        return (React.createElement("td", null,
            React.createElement(Text, null, dataItem.details || '--')));
    }
    if (typeof dataItem.assetDetails === 'object') {
        return (React.createElement("td", null, Object.entries(dataItem.assetDetails).map(([key, value]) => (React.createElement("div", { key: key },
            React.createElement(Text, null,
                React.createElement("strong", null, key),
                ": ",
                value))))));
    }
    return (React.createElement("td", null,
        React.createElement(Text, null, dataItem.assetDetails)));
}
export function ResolvedCell({ dataItem }) {
    return (React.createElement("td", null,
        React.createElement(Text, null, dataItem.isResolved ? translate('yes', { namespace: 'generic' }) : translate('no', { namespace: 'generic' }))));
}
